import clsx from "clsx";

const SkeletonType1: React.FC<{ className?: string }> = (props) => {
  return (
    <div role="status" className={clsx("max-w-sm animate-pulse", props?.className)}>
      <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-400 w-48 mb-4"></div>
      <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-400 max-w-[360px] mb-2.5"></div>
      <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-400 max-w-[300px] mb-2.5"></div>
      <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-400 max-w-[360px]"></div>
      <span className="sr-only">Loading...</span>
    </div>
  );
};
export default SkeletonType1;
